import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener('scroll', () => {
      window.dispatchEvent(new CustomEvent('containerScrolled'));
    });
  }
}
